export default "__VITE_ASSET__Bv2lxOT9__"